import config from './Config';
import EventSystem from './Events';
import { fetch } from 'whatwg-fetch'
var requiredTriggerTypes = [
    'timer',
    'idle_timer',
    'timer_from_the_beginning_of_the_visit'
];

function Util() {
    if (Util.__instance) {
        return Util.__instance;
    } else if (this === window) {
        return new Util();
    }

    Util.__instance = this;

    function TIME() {
        this.DAY = 1;
        this.WEEK = 7;
        this.MONTH = 30;
        this.YEAR = 365;
    }

    this.TIME = new TIME;

    this.domainZones = ['com.by', 'ru.com', 'ru.net', 'com.ru', 'do.ko', 'net.ru', 'org.ru', 'pp.ru', 'msk.ru', 'msk.su', 'spb.ru', 'spb.su', 'com.ua', 'co.ua', 'biz.ua', 'pp.ua', 'co.am', 'com.am', 'net.am', 'org.am', 'com.kz', 'org.kz', 'bir.ru', 'cbg.ru', 'nov.ru', 'nov.su', 'eu.com', 'co.at', 'or.at', 'com.es', 'nom.es', 'org.es', 'gb.net', 'gr.com', 'hu.net', 'co.im', 'com.im', 'net.im', 'org.im', 'ans.lv', 'com.lv', 'edu.lv', 'id.lv', 'net.lv', 'org.lv', 'com.pl', 'net.pl', 'org.pl', 'biz.pl', 'edu.pl', 'nom.pl', 'waw.pl', 'se.net', 'co.uk', 'org.uk', 'me.uk', 'uk.com', 'uk.net', 'com.ro', 'com.de', 'de.com', 'ae.org', 'com.af', 'net.af', 'org.af', 'cn.com', 'co.in', 'net.in', 'in.net', 'org.in', 'gen.in', 'ind.in', 'jp.net', 'jpn.com', 'com.my', 'net.my', 'org.my', 'com.ph', 'net.ph', 'org.ph', 'sa.com', 'com.tw', 'idv.tw', 'us.com', 'us.org', 'co.ag', 'com.ag', 'net.ag', 'org.ag', 'nom.ag', 'br.com', 'co.bz', 'com.bz', 'net.bz', 'org.bz', 'com.co', 'co.com', 'net.co', 'nom.co', 'com.ec', 'net.ec', 'pro.ec', 'med.ec', 'fin.ec', 'co.gl', 'com.gl', 'net.gl', 'org.gl', 'co.gy', 'com.gy', 'net.gy', 'com.hn', 'net.hn', 'org.hn', 'com.ht', 'net.ht', 'org.ht', 'co.lc', 'com.lc', 'net.lc', 'org.lc', 'com.mx', 'mex.com', 'com.pe', 'net.pe', 'org.pe', 'com.vc', 'net.vc', 'org.vc', 'co.ve', 'com.ve', 'co.cm', 'com.cm', 'net.cm', 'com.ki', 'net.ki', 'org.ki', 'biz.ki', 'com.ly', 'com.mu', 'net.mu', 'org.mu', 'com.nf', 'net.nf', 'org.nf', 'com.ng', 'net.ng', 'co.nz', 'net.nz', 'org.nz', 'com.sb', 'net.sb', 'org.sb', 'com.sc', 'net.sc', 'org.sc', 'za.com', 'co.za', 'net.za', 'org.za', 'web.za', 'net.so', 'in.ua', 'org.ua', 'net.ua', 'ck.ua', 'cn.ua', 'cv.ua', 'dn.ua', 'dp.ua', 'if.ua', 'kh.ua', 'km.ua', 'kr.ua', 'ks.ua', 'lg.ua', 'lt.ua', 'mk.ua', 'od.ua', 'pl.ua', 'rv.ua', 'sm.ua', 'te.ua', 'uz.ua', 'vn.ua', 'zp.ua', 'zt.ua', 'ar.com', 'com.se', 'gb.com', 'hu.com', 'kr.com', 'no.com', 'qc.com', 'se.com', 'uy.com', 'za.bz'];

    function getDomain(url) {
        var zone,
            domain,
            domainParts,
            isTwoLevelZone = false;

        for ( var key in Util.__instance.domainZones )
        {
            var value = Util.__instance.domainZones[ key ];

            if ( url.indexOf( "." + value ) > 0 )
            {
                zone = value;
                isTwoLevelZone = true;
            }
        }

        if ( isTwoLevelZone == false )
        {
            zone = url.split('.').pop();
        }

        domain = url.replace('.' + zone, '');

        domainParts = domain.split('.');

        var lenDomainParts = domainParts.length;

        if  ( lenDomainParts === 1 )
        {
            return domainParts.join() + "." + zone;
        } else {

            var lenFor = lenDomainParts - 1;

            for ( var i = 0; i < lenFor; i++ )
            {
                domainParts.shift();
            }

            return domainParts.join() + "." + zone;

        }

    }

    this.originDomain = getDomain(location.hostname);

    function Cookie() {

        function extend () {
            var i = 0;
            var result = {};
            for (; i < arguments.length; i++) {
                var attributes = arguments[ i ];
                for (var key in attributes) {
                    result[key] = attributes[key];
                }
            }
            return result;
        }

        this.set = function (key, value, options) {

            options = options || {};

            var maxAgeCookie =  options.hasOwnProperty('expires') && typeof options.expires === 'number' ? (options.expires * 24 * 60 * 60) : null

            if (!window.hasOwnProperty('lh_tracker_for_current_host')) {
                options.domain = Util.__instance.originDomain;
            }

            options = extend({
                path: '/'
            }, {}, options);

            if (typeof options.expires === 'number') {
                var expires = new Date();
                expires.setMilliseconds(expires.getMilliseconds() + options.expires * 864e+5);
                options.expires = expires;
            }

            // We're using "expires" because "max-age" is not supported by IE
            options.expires = options.expires ? options.expires : '';

            var result;
            try {
                result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) {
                    value = result;
                }
            } catch (e) {}

            value = encodeURIComponent(String(value))
                .replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

            key = encodeURIComponent(String(key));
            key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
            key = key.replace(/[\(\)]/g, escape);

            var stringifiedAttributes = '';

            for (var attributeName in options) {
                if (!options[attributeName]) {
                    continue;
                }
                stringifiedAttributes += '; ' + attributeName;
                if (options[attributeName] === true) {
                    continue;
                }
                stringifiedAttributes += '=' + options[attributeName];
            }

            // add use "max-age" because "expires" not working in iOS

            if (maxAgeCookie) {
                var maxAgeStringifiedAttribute = '; max-age=' + maxAgeCookie
                stringifiedAttributes += maxAgeStringifiedAttribute
            }

            return (document.cookie = key + '=' + value + stringifiedAttributes);

        }

        this.get = function (name) {

            if (document.cookie.length > 0) {
                var offset = document.cookie.indexOf(name + "=");
                if (offset != -1) {
                    offset = offset + name.length + 1;
                    var tail = document.cookie.indexOf(";", offset);
                    if (tail == -1) tail = document.cookie.length;
                    return unescape(document.cookie.substring(offset, tail));
                }
            }
            return null;

        }

        this.remove = function (name, options) {

            options = options || {};

            options.expires = -1

            return this.set(name, '', options);

        }

    }

    this.cookie = new Cookie;

    function Console(Util) {

        this.log = function() {
            if (Util.cookie.get('leadhit_frontend_debug')) {
                var arg = new Array();
                for (var i = 0; i < arguments.length; i++) { arg[i] = arguments[i]; }
                console.log.apply(console, ['Leadhit:'].concat(arg));
            }
        }

        this.warn = function() {
            if (Util.cookie.get('leadhit_frontend_debug')) {
                var arg = new Array();
                for (var i = 0; i < arguments.length; i++) { arg[i] = arguments[i]; }
                console.warn.apply(console, ['Leadhit:'].concat(arg));
            }
        }

        this.error = function() {
            if (Util.cookie.get('leadhit_frontend_debug')) {
                var arg = new Array();
                for (var i = 0; i < arguments.length; i++) { arg[i] = arguments[i]; }
                console.error.apply(console, ['Leadhit:'].concat(arg));
            }
        }

    }

    this.console = new Console(this);

    function getStyleTagByCSSText (css, saveNames, randomizeName, id, stripComments, parseCSS, getCSSForEditor, getSpaces, getCSSOfRules, parseRules, generateId, isEnableLHDOMElementsReplacer) {

        this.generateId = generateId
        this.isEnableLHDOMElementsReplacer = isEnableLHDOMElementsReplacer
        this.possibleSymbols = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"
        let regUrlsInCss = /(url\([\"|\'](.*?)[\"|\']\))|(url\([\"|\'].*\n\s+.*[\"|\']\))/gmi
        let originalUrlsInCss = css.match(regUrlsInCss)

        // remove comments, spaces, tabs, newlines
        css = stripComments(css)
    
        css = (function runParser(css) {
            let parsed = parseCSS(css, parseCSS, parseRules)

            for(let key = 0; key < parsed.length; key++) {

                let selector = parsed[key].selector

                if ( selector.search('#') >= 0 )
                {
                    selector = selector.replace(/\#([\w-]+)/gm, ($0, $1) => {
                        if ( !saveNames[ $1 ] )
                            saveNames[ $1 ] = randomizeName.call(this, $1)
                        return `#${saveNames[ $1 ]}`
                    })
                }

                if ( selector.search('.') >= 0 )
                {
                    selector = selector.replace(/\.([\w-]+)/gm, ($0, $1) => {
                        if ( !saveNames[ $1 ] ) {
                            saveNames[ $1 ] = randomizeName.call(this, $1)
                        }
                        return `.${saveNames[ $1 ]}`
                    })
                }

                if ( parsed[key].hasOwnProperty('subStyles') )
                {
                    let styles = parsed[ key ][ 'subStyles' ]
                    if ( styles )
                    {
                        parsed[ key ][ 'subStyles' ] = runParser(getCSSForEditor(styles, 0, getSpaces, getCSSOfRules, getCSSForEditor))
                    }
                }

                if ( selector.search('@') === -1 )
                {
                    selector = `#${saveNames['lhWidgetItem-' + id]} ${selector.split(',').join(',#' + saveNames['lhWidgetItem-' + id])}`
                }

                parsed[key].selector = selector
            }

            return parsed
        })(css)

        css = getCSSForEditor(css, 0, getSpaces, getCSSOfRules, getCSSForEditor)

        let newUrlsInCss = css.match(regUrlsInCss)
        if ( originalUrlsInCss !== null && newUrlsInCss !== null ) {
            for(let i = 0; i < originalUrlsInCss.length; i++) {
                css = css.replace(newUrlsInCss[ i ], originalUrlsInCss[ i ])
            }
        }

        return {
            css: css,
            saveNames: saveNames
        }
    }

    this.getStyleTagByCSSText = getStyleTagByCSSText

    function getPromisesByUrls (id) {
      if(window.Leadhit.store.state.siteSettings.hasOwnProperty('next_vers_features') && 
        window.Leadhit.store.state.siteSettings.next_vers_features.hasOwnProperty('widgets') && 
        window.Leadhit.store.state.siteSettings.next_vers_features.widgets === true) {

          if(ENV === 'development') {
            let htmlUrl = `http://127.0.0.1:8008/widget/render?site_id=${config.site_id}&widget_id=${id}&extension=html&use_cache=false`
            let cssUrl = `http://127.0.0.1:8008/widget/render?site_id=${config.site_id}&widget_id=${id}&extension=css&use_cache=false`
            let jsUrl = `http://127.0.0.1:8008/widget/render?site_id=${config.site_id}&widget_id=${id}&extension=js&use_cache=false`

            var promises = [htmlUrl, cssUrl, jsUrl].map(url => fetch(url).then(resp => resp.text()))
          }
          else if(ENV === 'production') {
            let use_cache = config.preview ? false : true
            let htmlUrl = `https://track-api.leadhit.io/widget/render?site_id=${config.site_id}&widget_id=${id}&extension=html&use_cache=${use_cache}`
            let cssUrl = `https://track-api.leadhit.io/widget/render?site_id=${config.site_id}&widget_id=${id}&extension=css&use_cache=${use_cache}`
            let jsUrl = `https://track-api.leadhit.io/widget/render?site_id=${config.site_id}&widget_id=${id}&extension=js&use_cache=${use_cache}`

            var promises = [htmlUrl, cssUrl, jsUrl].map(url => fetch(url).then(resp => resp.text()))
          }
      }
      else {
        if(config.preview) {
          var url = `${config.baseUrl}`
  
          var promises = ["html", "css", "js"].map(extension => {
            var params = {
              "site_id": config.site_id,
              "widget_id": id,
              "extension": extension,
              "widgets_path": config.widgets_path
            }
            if(config.preview) {
              params.widget_config = window.top.lh_widgets_conf_demo['widgets'][id]
            }
            return fetch(url, { 
                                method: 'POST', 
                                headers: {
                                  'Accept': 'application/json',
                                  'Content-Type': 'application/json'
                                },
                                body:JSON.stringify(params)
                            }).then(resp => {
                                return resp.text()
                            })
          })
        }
        else {
            let widget_path = (config.widgets_path && config.widgets_path.length > 0) ? `&widgets_path=${config.widgets_path}` : ''
            var htmlUrl = `${config.baseUrl}?site_id=${config.site_id}&widget_id=${id}&extension=html${widget_path}`
            var cssUrl = `${config.baseUrl}?site_id=${config.site_id}&widget_id=${id}&extension=css${widget_path}`
            var jsUrl = `${config.baseUrl}?site_id=${config.site_id}&widget_id=${id}&extension=js${widget_path}`
    
            var promises = [htmlUrl, cssUrl, jsUrl].map(url => fetch(url).then(resp => resp.text()))
        }
      }

      return promises
    }

    this.getPromisesByUrls = getPromisesByUrls

    function setTriggers(options, validator, widgetId, showMethod) {
        var requiredTypes = requiredTriggerTypes.slice();
        if(showMethod) {
            for (var triggerType in options.triggers) {
                var value = options.triggers[triggerType];

                var requiredTriggerTypePosition = requiredTypes.indexOf(triggerType, 0);
                if (requiredTriggerTypePosition !== -1) {
                    requiredTypes.splice(requiredTriggerTypePosition, 1);
                }

                EventSystem.listen(widgetId, triggerType, value, showMethod, validator);
            }
        }

        requiredTypes.forEach(function(type) {
            EventSystem.listen(widgetId, type, null, null, validator);
        });
    }

    this.setTriggers = setTriggers

    var send_request_flag = true
    var send_request_timer = null
    function getTrackerBackendBackgroundResult(result_id, result_type, stop_time=120000) {
      if(ENV === 'production') {
        var request_url = `https://track-api.leadhit.io/get/task/result?result_id=${result_id}&result_type=${result_type}`
      }
      else if(ENV === 'development') {
        var request_url = `http://127.0.0.1:8008/get/task/result?result_id=${result_id}&result_type=${result_type}`
      }

      if(!send_request_timer) {
        send_request_timer = setTimeout(function() {
          send_request_flag = false
        }.bind(this), stop_time)
      }
    
      return fetch(request_url).then(resp => resp.text())
      .then(function(response) {
        response = JSON.parse(response)
        if(!send_request_flag) {
          return 'error'
        }
        if(response.ready === false) {
          return getTrackerBackendBackgroundResult.call(this, result_id, result_type)
        }
        else if(response.ready === true) {
          return response
        }
        else {
          this.console.log('Error in getTrackerBackendBackgroundResult response', response)
        }
      }.bind(this))
    }

    this.getTrackerBackendBackgroundResult = getTrackerBackendBackgroundResult

    this.isMobile = function() {
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    }
}

window.Leadhit.Util = new Util;

export default window.Leadhit.Util;
